(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/util.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/util.js');
"use strict";


const hideFooter = () => {
  var _document$querySelect;
  return (_document$querySelect = document.querySelector('.page-footer')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.classList.add('hide-page-footer');
};
const showFooter = () => {
  var _document$querySelect2;
  return (_document$querySelect2 = document.querySelector('.page-footer')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.classList.remove('hide-page-footer');
};
const validateGameConfig = gameConfig => {
  try {
    const {
      playUrl,
      demoUrl,
      infoUrl,
      minPrice,
      name,
      maxWin,
      url,
      type,
      imageBackground
    } = gameConfig;
    const requiredObj = {
      playUrl,
      demoUrl,
      infoUrl,
      minPrice,
      name,
      maxWin,
      type,
      url,
      imageBackground
    };
    const missingKeys = Object.keys(requiredObj).filter(key => !requiredObj[key]);
    if (missingKeys.length > 0) {
      svs.eInstant.logger.warn("Failed to display \"".concat(name || url || undefined, "\" with missing keys: ").concat(missingKeys.join(', ')));
      return false;
    }
    if (!gameConfig.open) {
      svs.eInstant.logger.warn("Game \"".concat(name || url || 'unknown', "\" is not open (status: ").concat(gameConfig.status, ")"));
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
};
const validateFeaturedGame = featuredGame => {
  try {
    if (!featuredGame) {
      svs.eInstant.logger.warn('Featured game is null or undefined');
      return false;
    }
    const {
      featuredGameImage,
      name,
      playUrl,
      demoUrl
    } = featuredGame;
    const requiredFields = {
      featuredGameImage,
      name,
      playUrl,
      demoUrl
    };
    const missingKeys = Object.keys(requiredFields).filter(key => !requiredFields[key]);
    if (missingKeys.length > 0) {
      svs.eInstant.logger.warn("Failed to display featured game \"".concat(name || 'unknown', "\" with missing keys: ").concat(missingKeys.join(', ')));
      return false;
    }
    return true;
  } catch (e) {
    svs.eInstant.logger.warn("Error validating featured game: ".concat(e.message));
    return false;
  }
};
const getMetaTags = (seoTitle, seoDescription, seoKeywords) => [{
  attribute: 'name',
  attributeValue: 'description',
  content: seoDescription
}, {
  attribute: 'name',
  attributeValue: 'keywords',
  content: seoKeywords
},
{
  attribute: 'property',
  attributeValue: 'og:title',
  content: seoTitle
}, {
  attribute: 'property',
  attributeValue: 'og:description',
  content: seoDescription
},
{
  attribute: 'name',
  attributeValue: 'twitter:title',
  content: seoTitle
}, {
  attribute: 'name',
  attributeValue: 'twitter:description',
  content: seoDescription
}];
const setMetaTags = (seoTitle, seoDescription, seoKeywords) => {
  const tags = getMetaTags(seoTitle, seoDescription, seoKeywords);
  for (const {
    attribute,
    attributeValue,
    content
  } of tags) {
    const existingTag = document.querySelector("meta[".concat(attribute, "=\"").concat(attributeValue, "\"]"));
    const metaTag = existingTag ? existingTag : document.createElement('meta');
    metaTag.setAttribute('content', content);
    svs.eInstant.logger.debug("Added tag: ".concat(attribute, "=\"").concat(attributeValue, "\" content=\"").concat(content, "\""));
    if (!existingTag) {
      metaTag.setAttribute(attribute, attributeValue);
      document.getElementsByTagName('head')[0].appendChild(metaTag);
      svs.eInstant.logger.debug("Added meta tag: ".concat(attribute, "=\"").concat(attributeValue, "\" content=\"").concat(content, "\""));
    }
  }
};
const infoPageMatch = () => {
  const {
    INFO,
    ALL_GAMES_INFO,
    CATEGORY_INFO,
    FAVORITES_INFO
  } = svs.eInstant.constants.ROUTES;
  const {
    matchPath
  } = svs.app.ReactRouter;
  let match;
  const routes = [INFO, ALL_GAMES_INFO, CATEGORY_INFO, FAVORITES_INFO];
  for (const route of routes) {
    match = matchPath(window.location.pathname, {
      path: "".concat(svs.core.data.baseUrl).concat(route),
      exact: true,
      strict: false
    });
    if (match) {
      break;
    }
  }
  return match;
};
setGlobal('svs.eInstant.util', {
  hideFooter,
  showFooter,
  setMetaTags,
  getMetaTags,
  validateGameConfig,
  infoPageMatch,
  validateFeaturedGame
});

 })(window);